export class RecordingDoesNotHaveSttError extends Error {
  constructor() {
    super('Cannot regenerate text for a recording that does not already have text. Please click Get Text first.')
    Object.setPrototypeOf(this, RecordingDoesNotHaveSttError.prototype)
  }
}
